export default "The Boomer needs to go as far as possible! Help him out by placing bombs.";